
import { defineComponent } from "vue";

import { toolbarWidthFluid } from "@/core/helpers/config";
import { CookieComponent } from "@/assets/ts/components/_CookieComponent";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "KToolbar",
  props: {
    breadcrumbs: Array,
    title: String,
  },
  computed: {
    userName() {
      return CookieComponent.get("fullName");
    },
  },
  setup() {
    const { t, te } = useI18n();
    const translate = (text) => {
      if (te(text)) {
        return t(text);
      } else {
        return text;
      }
    };
    return {
      toolbarWidthFluid,
      translate,
    };
  },
});
